import { toast } from 'react-toastify';

import { useInvalidateQueries, useLocale, VaultHooks } from '../../../../hooks/index';
import { selectedCompanyStorage } from '../../../../storage/company/selected-company.util';
import { VAULT_FILE_INVALIDATION_KEYS } from '../../constants/spaces-query.const';

export type RenameVaultFileVariables = {
  fileId: string;
  folderId: string;
  // The stored link goes back with the name, as the Vault page sends it: the server keys the
  // object's display name on it.
  link: string;
  name: string;
};

type Props = {
  onSuccess?: () => void;
};

// A Vault file renamed through the Vault's own route, said and refreshed as the Vault page does.
export const useRenameVaultFile = ({ onSuccess }: Props = {}) => {
  const companyId = selectedCompanyStorage(({ companyId: selected }) => selected);
  const { messagesLocale } = useLocale();
  const { invalidateQuery } = useInvalidateQueries(...VAULT_FILE_INVALIDATION_KEYS);
  const { isPending, renameFile } = VaultHooks.useRenameFile();

  const rename = ({ fileId, folderId, link, name }: RenameVaultFileVariables) =>
    renameFile(
      { companyId, data: { folderId, link, name }, fileId },
      {
        onSuccess: () => {
          toast.success(messagesLocale['FILE_RENAMED_SUCCESS']);
          invalidateQuery();
          onSuccess?.();
        },
      },
    );

  return { isPending, renameFile: rename };
};
